import { formatCurrency, toUnitCharacter } from "@sa-nu/shared-utils/price";
import type { ReactNode } from "react";

import type { FacilityFeeWaiver } from "./_utils/facility-fee-waiver";
import {
  facilityLowerClassNoAdditionalFeeOnStraddling,
  facilityWaivedFee,
  NO_FACILITY_FEE_WAIVER,
} from "./_utils/facility-fee-waiver";
import { DescriptionHeader } from "./description-header";

export type DescriptionForDogRunMessages = {
  heading: ReactNode;
  feePerNight: (formattedFee: string) => string;
  noAdditionalFee: string;
  dynamicPricingNote: string;
  unitCharacter: string;
};

const JA_MESSAGES: DescriptionForDogRunMessages = {
  heading: (
    <>
      こちらのキャビンには、
      <br />
      ドッグランが設置されています
    </>
  ),
  feePerNight: (formattedFee) =>
    `1泊あたり ${formattedFee}（税込）のドッグラン利用料金がかかります。`,
  noAdditionalFee: "追加料金はかかりません。",
  dynamicPricingNote:
    "※ ただし、「お部屋・日程による変動料金」にはドッグラン利用料金が含まれています",
  unitCharacter: "円",
};

/**
 * ドッグランの説明
 */
export function DescriptionForDogRun({
  additionalFee,
  hasDynamicPricing = false,
  feeWaiver = NO_FACILITY_FEE_WAIVER,
  messages = JA_MESSAGES,
}: {
  additionalFee: number;
  hasDynamicPricing?: boolean;
  feeWaiver?: FacilityFeeWaiver;
  messages?: DescriptionForDogRunMessages;
}) {
  // 改定日を跨ぐ滞在のみ、課金の表示をした上で、改定日以降は下位クラスで免除になる表示をする
  // 移行期間が終わったら削除する
  const isLowerClassWaivedOnStraddling =
    additionalFee > 0 && feeWaiver.reason === "LowerClass";
  return (
    <div className="mt-[20px] w-full space-y-[20px]">
      <DescriptionHeader iconSrc="/i/icon_dogrun.svg" iconAlt="Dog Run">
        {messages.heading}
      </DescriptionHeader>
      <div className="text-xs md:text-sm">
        {isLowerClassWaivedOnStraddling
          ? facilityLowerClassNoAdditionalFeeOnStraddling(
              feeWaiver.accommodationClass,
            )
          : additionalFee > 0
            ? messages.feePerNight(
                formatCurrency(additionalFee, {
                  unitCharacter: toUnitCharacter(messages.unitCharacter),
                }),
              )
            : feeWaiver.reason === "None"
              ? messages.noAdditionalFee
              : facilityWaivedFee(feeWaiver)}
        {hasDynamicPricing && (
          <>
            <br />
            <span className="text-skogecha-60">
              {messages.dynamicPricingNote}
            </span>
          </>
        )}
      </div>
    </div>
  );
}
